import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={process.env.PUBLIC_URL + '/logochurros.png'} alt="Churros ATX" />
              <span>Churros ATX</span>
            </div>
            <p className="footer__tagline">
              The traditional taste of Mexico, hand-made in Texas. 
              Every treat is hand-pressed with love using family recipes and local ingredients.
            </p>
          </div>
          <div className="footer__links-group">
            <h4>Quick Links</h4>
            <ul>
              <li onClick={() => scrollToSection('about')}>About Us</li>
              <li onClick={() => scrollToSection('menu')}>Our Menu</li>
              <li onClick={() => scrollToSection('favorites')}>Local Favorites</li>
              <li onClick={() => scrollToSection('gallery')}>Gallery</li>
              <li onClick={() => scrollToSection('catering')}>Catering & Events</li>
              <li onClick={() => scrollToSection('contact')}>Contact</li>
            </ul>
          </div>
          <div className="footer__links-group">
            <h4>Hours</h4>
            <ul className="footer__hours">
              <li>Tuesday – Saturday: 8am – 3pm</li>
            </ul>
          </div>
          <div className="footer__links-group">
            <h4>Follow Us</h4>
            <div className="footer__social">
              <a href="#!" aria-label="Instagram">Instagram</a>
              <a href="#!" aria-label="Facebook">Facebook</a>
              <a href="#!" aria-label="TikTok">TikTok</a>
              <a href="#!" aria-label="Yelp">Yelp</a>
            </div>
          </div>
        </div>
        <div className="footer__divider"></div>
        <div className="footer__bottom">
          <p>Copyright © {currentYear} Churros ATX — All Rights Reserved.</p>
          <p className="footer__powered">
            Powered by <span>Churros ATX</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
